import { AppointmentCancellationLeadTime } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { RadioFilterSelector, FilterTraySection } from '@frontend/analytics-shared';
import { useTranslation, i18next } from '@frontend/i18n';
import { trackingIds } from '../../tracking-ids';

const leadTimeOptions = {
  [AppointmentCancellationLeadTime.CANCEL_LEAD_TIME_0_1_DAYS]: i18next.t('Same day', { ns: 'analytics' }),
  [AppointmentCancellationLeadTime.CANCEL_LEAD_TIME_1_3_DAYS]: i18next.t('1 to 3 days', { ns: 'analytics' }),
  [AppointmentCancellationLeadTime.CANCEL_LEAD_TIME_4_10_DAYS]: i18next.t('4 to 10 days', { ns: 'analytics' }),
  [AppointmentCancellationLeadTime.CANCEL_LEAD_TIME_10_PLUS_DAYS]: i18next.t('> 10 days', { ns: 'analytics' }),
};
interface AppointmentCancellationLeadTimeTrayFilterProps {
  value?: AppointmentCancellationLeadTime;
  onChange: (leadTime?: AppointmentCancellationLeadTime) => void;
}

export const AppointmentCancellationLeadTimeTrayFilter = ({
  value,
  onChange,
}: AppointmentCancellationLeadTimeTrayFilterProps) => {
  const { t } = useTranslation('analytics');

  return (
    <FilterTraySection label={t('Cancellation lead time')} onReset={() => onChange(undefined)} disableReset={!value}>
      <RadioFilterSelector<AppointmentCancellationLeadTime>
        options={leadTimeOptions}
        label={t('Cancellation lead time')}
        onChange={(val) => {
          onChange(val as AppointmentCancellationLeadTime);
        }}
        value={value}
        showLabel={false}
        withBorder={false}
        trackingId={`${trackingIds.filterTrayToggle}-cancel-lead-time`}
      />
    </FilterTraySection>
  );
};
